import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/svgs/empty.svg'


const _hoisted_1 = { class: "w-full bg-gray-100 h-full items-center rounded-2xl p-5 flex flex-col justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-44"
  })
], -1)
const _hoisted_3 = { class: "flex flex-row justify-center pt-3" }
const _hoisted_4 = { class: "text-3xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1)
    ])
  ]))
}